// Replaces placeholders in a string with values from a context object
// e.g. format("Hello {name}.", {name: "World"}) => "Hello World."
export function format(text: string, context: Record<string, string>): string {
  return text.replace(/{(\w+)}/g, (match, key) => {
    return context[key] || match
  })
}

// Helper to parse ISO date as local date
function parseLocalDate(isoDateStr: string) {
  const [year, month, day] = isoDateStr.split('-').map(Number)
  return new Date(year, month - 1, day)
}

// Formats a release (2025-02-14) to a date (February 2025)
export function formatRelease(release: string): string {
  const date = parseLocalDate(release)
  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  })
}
